import { render, staticRenderFns } from "./FutureShow.vue?vue&type=template&id=447513bf&scoped=true&"
import script from "./FutureShow.vue?vue&type=script&lang=js&"
export * from "./FutureShow.vue?vue&type=script&lang=js&"
import style0 from "./FutureShow.vue?vue&type=style&index=0&id=447513bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447513bf",
  null
  
)

export default component.exports